import React from 'react';
import { motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { spring } from '../../utils/motion';
interface NumberStepperProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  step: number;
  min?: number;
  max?: number;
  format?: (value: number) => string;
  hint?: string;
}
export function NumberStepper({
  label,
  value,
  onChange,
  step,
  min = 0,
  max = Infinity,
  format = String,
  hint
}: NumberStepperProps) {
  const set = (v: number) => onChange(Math.min(max, Math.max(min, Math.round(v * 100) / 100)));
  return <div className="flex items-center justify-between gap-4" data-id="element-801" data-mp="2jvjzty1hziul">
      <div className="min-w-0" data-id="element-802" data-mp="2jt7i9lznjai2">
        <p className="text-[15px] font-bold" data-id="element-803" data-mp="2nwncycs5v0s4">{label}</p>
        {hint && <p className="text-sm text-ink-3" data-id="element-804" data-mp="2nusqgu18r0lx">{hint}</p>}
      </div>
      <div className="flex shrink-0 items-center gap-1 rounded-full bg-surface-2 p-1" data-id="element-805" data-mp="3blew6enrw8sr">
        <StepButton label={`Decrease ${label}`} onClick={() => set(value - step)} disabled={value <= min} data-id="element-806" data-mp="3gdg3rn9zxbcg">
          <MinusIcon className="h-4 w-4" data-id="element-807" data-mp="2gagtlsnjargo" />
        </StepButton>
        <motion.span key={value} initial={{
        y: 6,
        opacity: 0.4
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={spring.snappy} className="tabular min-w-[72px] text-center text-[15px] font-bold" aria-live="polite" data-id="element-808" data-mp="2bacaduv8rimr">
          {format(value)}
        </motion.span>
        <StepButton label={`Increase ${label}`} onClick={() => set(value + step)} disabled={value >= max} data-id="element-809" data-mp="2yz59u1b2o8m4">
          <PlusIcon className="h-4 w-4" data-id="element-810" data-mp="2uxa3gieab51h" />
        </StepButton>
      </div>
    </div>;
}
function StepButton({
  label,
  onClick,
  disabled,
  children
}: {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
}) {
  return <motion.button type="button" aria-label={label} onClick={onClick} disabled={disabled} whileTap={{
    scale: 0.85
  }} transition={spring.snappy} className="grid h-9 w-9 place-items-center rounded-full bg-surface text-ink shadow-sm transition-opacity duration-150 disabled:opacity-40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-811" data-mp="33x6s4k0oc3wj">
      {children}
    </motion.button>;
}